@import 'styles/mixins';
@import 'styles/variables';

.buttonContainer {
  width: 100%;
  display: flex;
  gap: 12px;
}

.rightButtons {
  margin-left: auto;
  width: auto;
}
